import { createFileRoute } from '@tanstack/react-router'

import { OrganisationSettings } from '@/widgets/organisation-settings'

export const Route = createFileRoute('/_app/settings/organisation')({
  component: RouteComponent,
})

export const OrganisationSettingsRoute = Route

function RouteComponent() {
  return <OrganisationSettings />
}
